import {Show, Text} from 'platform/foundation';
import {CurrencyFormat} from 'platform/locale';

import {useCustomerInsightsBusinessCasePrice} from '../../../hooks/useCustomerInsightsBusinessCasePrice';
import type {CustomerInsightsBusinessCaseRecord} from '../../../types/CustomerInsightsViewModel';
import {CustomerInsightsEnrichmentStatus} from './CustomerInsightsEnrichmentStatus';

interface CustomerInsightsHistoryBusinessCasePriceProps {
  record: CustomerInsightsBusinessCaseRecord;
}

export function CustomerInsightsHistoryBusinessCasePrice(
  props: CustomerInsightsHistoryBusinessCasePriceProps
) {
  const {
    price,
    canReadPrice,
    isLoading: isBusinessCasePriceLoading,
    isError: isBusinessCasePriceError,
    retry: retryBusinessCasePrice,
  } = useCustomerInsightsBusinessCasePrice(props.record);

  const priceContent = (
    <Show when={canReadPrice && price !== undefined}>
      <Text
        size="xSmall"
        alternative
        noWrap
        data-testid={`customerInsights-history-${props.record.id}-price`}
      >
        <CurrencyFormat number={price?.amount ?? 0} currency={price?.currency ?? ''} />
      </Text>
    </Show>
  );

  return canReadPrice ? (
    <CustomerInsightsEnrichmentStatus
      isLoading={isBusinessCasePriceLoading}
      isError={isBusinessCasePriceError}
      retry={retryBusinessCasePrice}
    >
      {priceContent}
    </CustomerInsightsEnrichmentStatus>
  ) : (
    priceContent
  );
}
